<script lang="ts" setup></script>

<template>
  <h1 class="ris-heading2-regular mb-24">
    <span class="font-bold">404</span> - Seite nicht gefunden
  </h1>
  <div class="flex w-full flex-col gap-12 md:w-1/2">
    <p>
      Wenn Sie die Webadresse eingegeben haben, überprüfen Sie, ob sie korrekt
      ist.
    </p>
    <p>
      Wenn Sie die Webadresse eingefügt haben, überprüfen Sie, ob Sie die
      gesamte Adresse kopiert haben.
    </p>
    <p>
      Wenn die Webadresse korrekt ist oder Sie einen Link oder eine Schaltfläche
      ausgewählt haben, wenden Sie sich an den NeuRIS-Support.
    </p>
  </div>
</template>
